export default __webpack_public_path__ + "48e8f5c831bc418ccf426b1e4ba48de8.svg";